import React from "react";
import SideBar from "../../components/Sidebar";
import { APP_INFO } from "../../constants/AppInfo";

const PrivacyPolicy = () => {
  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Privacy Policy</h5>
                <div className="row">
                  <div className="container my-4">
                    <div className="row">
                      <div className="col-md-12">
                        <section id="privacy-policy">
                          <h6>Privacy Policy for {APP_INFO.companyName}</h6>
                          <p>
                            <strong>Last Updated:</strong> 01.01.2025
                          </p>

                          <h6>1. Introduction</h6>
                          <p>
                            This Privacy Policy applies to{" "}
                            <strong>{APP_INFO.companyName}</strong>, a brand
                            operated by <strong>CHOTTU TELECOM</strong>, located
                            at Barasat - 1, Kathuria, Malikapur, Duttapukur,
                            Barasat, North 24 Parganas, West Bengal - 700126. By
                            accessing or using our platform and services, you
                            agree to the terms of this Privacy Policy.
                          </p>

                          <h6>2. Information We Collect</h6>
                          <p>
                            To provide recharge, bill payments and other digital
                            services, we collect the following information:
                          </p>
                          <ul>
                            <li>
                              <strong>Personal Information:</strong> Full name,
                              mobile number, email address, date of birth, and
                              residential address (where required for KYC or
                              regulatory purposes)
                            </li>
                            <li>
                              <strong>KYC Information (if applicable):</strong>{" "}
                              Officially valid identity and address verification
                              details collected in compliance with applicable
                              regulatory and RBI guidelines through authorized
                              banking or regulated partners.
                            </li>
                            <li>
                              <strong>Transaction Details:</strong> Mobile/DTH
                              numbers, transaction amount, date, time, status,
                              and payment reference IDs
                            </li>
                            <li>
                              <strong>Device & Technical Data:</strong> IP
                              address, browser type, operating system, device
                              ID, app version, and approximate geolocation
                              collected for security and fraud prevention
                            </li>
                            <li>
                              <strong>SMS/OTP & Authentication Data:</strong>{" "}
                              One-Time Passwords (OTP) and SMS data used only
                              for secure login, transaction authentication, and
                              fraud prevention, and accessed strictly with user
                              consent
                            </li>
                            <li>
                              <strong>Referral or Invite Data:</strong> Referral
                              codes and limited referral activity data when you
                              refer users or are referred by others
                            </li>
                          </ul>

                          <h6>3. How We Use Your Information</h6>
                          <ul>
                            <li>
                              To process recharges, bill payments, and other
                              transactions
                            </li>
                            <li>
                              To enable account loading, transaction processing,
                              and completion of KYC and regulatory compliance in
                              accordance with applicable RBI guidelines
                            </li>
                            <li>
                              To verify your identity and ensure secure access
                            </li>
                            <li>
                              To communicate important service-related updates
                            </li>
                            <li>
                              To detect and prevent fraud, abuse, or misuse of
                              services
                            </li>
                            <li>
                              To comply with regulatory and legal obligations
                            </li>
                          </ul>

                          <h6>4. Cookies & Tracking Technologies</h6>
                          <p>
                            We use cookies and similar tracking technologies to
                            enhance your experience, improve functionality, and
                            analyze usage patterns. You can control cookie
                            settings in your browser.
                          </p>
                          <h6>5. Data Sharing</h6>
                          <p>
                            We share user information strictly on a need-to-know
                            basis and only for the purpose of providing our
                            services. Your data may be shared with:
                          </p>
                          <ul>
                            <li>
                              <strong>
                                Authorized Banks and Payment Partners:
                              </strong>
                              For account loading, transaction processing,
                              settlement, KYC verification, fraud prevention,
                              and regulatory compliance in accordance with
                              applicable RBI guidelines.
                            </li>
                            <li>
                              <strong>
                                Telecom, DTH, and Utility Service Providers:
                              </strong>
                              To successfully fulfill recharge and bill payment
                              requests initiated by users.
                            </li>
                            <li>
                              <strong>Service Providers:</strong>
                              Trusted third-party vendors engaged for essential
                              services such as analytics, cloud hosting,
                              customer support, or technical operations. These
                              parties are contractually bound to use data only
                              for specified purposes and maintain
                              confidentiality.
                            </li>
                            <li>
                              <strong>Legal and Regulatory Authorities:</strong>
                              Government bodies, law enforcement agencies, or
                              regulators when required to comply with applicable
                              laws, RBI regulations, court orders, or lawful
                              requests.
                            </li>
                          </ul>
                          <p>
                            We do not sell or rent user personal data to third
                            parties for advertising or marketing purposes.
                          </p>

                          <h6>6. Data Security</h6>
                          <p>
                            We employ industry-standard security practices to
                            safeguard your information, including:
                          </p>
                          <ul>
                            <li>
                              End-to-end data encryption during transmission
                            </li>
                            <li>Secure servers and infrastructure</li>
                            <li>
                              Two-factor authentication (2FA) for sensitive
                              actions
                            </li>
                            <li>Regular audits and vulnerability testing</li>
                          </ul>

                          <h6>7. Data Retention</h6>
                          <p>
                            We retain your data only as long as necessary to
                            provide services and comply with legal or regulatory
                            requirements. You may request deletion of your
                            account at any time, subject to regulatory retention
                            norms.
                          </p>

                          <h6>8. Your Rights</h6>
                          <p>You have the right to:</p>
                          <ul>
                            <li>Access your personal information held by us</li>
                            <li>
                              Request correction or update of inaccurate data
                            </li>
                            <li>
                              Delete your account and data (where permitted by
                              law)
                            </li>
                            <li>
                              Withdraw consent for non-essential communications
                            </li>
                          </ul>
                          <p>
                            To exercise any of these rights, please contact us
                            at the email provided below.
                          </p>

                          <h6>9. Children’s Privacy</h6>
                          <p>
                            Our services are not intended for use by children
                            under the age of 18. We do not knowingly collect
                            personal information from children.
                          </p>

                          <h6>10. Changes to This Policy</h6>
                          <p>
                            We may revise this Privacy Policy periodically.
                            Updates will be posted on this page and major
                            changes will be communicated through our app or
                            website. Continued use of our services constitutes
                            your agreement to the revised policy.
                          </p>
                          <h6>11. Grievance Redressal Officer</h6>
                          <p>
                            In accordance with RBI guidelines, users may contact
                            our Grievance Officer for any complaints or concerns
                            related to services.
                          </p>
                          <p>
                            <strong>Name:</strong> Grievance Officer
                            <br />
                            <strong>Email:</strong> {APP_INFO.email}
                            <br />
                            <strong>Address:</strong> Barasat - 1, Kathuria,
                            Malikapur, Duttapukur, Barasat, North 24 Parganas,
                            West Bengal - 700126
                          </p>
                          <p>
                            Complaints will be acknowledged within 48 hours and
                            resolved within a reasonable timeframe as per
                            applicable regulations.
                          </p>

                          <h6>12. Contact Us</h6>
                          <p>
                            <strong>Email:</strong>{" "}
                            <a href={`mailto:${APP_INFO.email}`}>
                              {APP_INFO.email}
                            </a>
                          </p>
                          <p>
                            <strong>Address:</strong> Barasat - 1, Kathuria,
                            Malikapur, Duttapukur, Barasat, North 24 Parganas,
                            West Bengal - 700126
                          </p>
                          <p>
                            <strong>Legal Owner:</strong> CHOTTU TELECOM
                          </p>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
